import { render, staticRenderFns } from "./EnhancedStatQueuePage.vue?vue&type=template&id=581881b4&scoped=true"
import script from "./EnhancedStatQueuePage.vue?vue&type=script&lang=js"
export * from "./EnhancedStatQueuePage.vue?vue&type=script&lang=js"
import style0 from "./EnhancedStatQueuePage.vue?vue&type=style&index=0&id=581881b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581881b4",
  null
  
)

export default component.exports